import React from 'react';
import Hero from "./components/reg-course/Hero";
import Main from "./components/reg-course/Main";

const RegCourses = () => {
  return (
    <div>
        <Hero />
        <Main />
    </div>
  )
}

export default RegCourses;